import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    // Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import LocalMallIcon from '@material-ui/icons/LocalMall';
//cookies
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const InventoryLocationTransfer = () => {
    const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();
    const [branchidNo, setbranchidNo] = useState(get_cookies('branchidno'));
	const [downloadFlag, setDownloadFlag] = useState(false);

	// const [initalLoad, setInitialLoad] = useState(true);
	
	// Data Fetching
	useEffect(() => {
		data();
	}, []);
	
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const { REACT_APP_API_URL } = process.env;

	//search button
	const dataFilter = async () => {
		setDataLoaded(false);	
        await axios.get(
				`${process.env.REACT_APP_API_URL}/getIlt`, {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: branchidNo,  //branchidNo
								// initalLoad //if initial load, will show latest 5 adjustment
            }
        }).then((res=>{
		console.log('343',res.data.data);
			setPosts(res.data.data);
			setDataLoaded(true);
		})).catch((error=>{
			// console.log(error.message)
		}))		
    }
    
    const data = async () => {
			setDataLoaded(true);	
			await dataFilter();
			// await setInitialLoad(false);
    };

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };
    
		//need columns centered
    const columns = [
            {
                name: "trandate",
                label: "Transaction Date",
								align: "center",
                options: {
									sort:true,
									// display: "excluded",
                },
            },
	    						{
							name: "itemlocid2",
							label: "Location",
							align: "center",
							options: {
							sort:true,
										// display: "excluded",
								},
						},
            {
                name: "iltno",
                label: "ILT No.",
								align: "center",
            },
	                {
                name: "pono",
                label: "PO No.",
								align: "center",
            },
	    	                {
                name: "status",
                label: "Status",
								align: "center",
		options: {
                    customBodyRenderLite: (dataIndex) => {
                        let status = posts[dataIndex].status;
                          
				if(status == 1){
					return "Converted to ILT";
				}else{
					return "Waiting for Conversion";
				}
                        
                    },
                }
            },


            {
                name: "iltno",
                label:"Actions",
								align: "center",
                options: {
					sort:false, 
					filter: false, 
                    customBodyRenderLite: (dataIndex) => {
                        let iltno = posts[dataIndex].iltno;
                            return (
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <NavLink to={"/inventory/inventory-location-transfer-view/"+iltno+"/"+branchidNo}>
                                            <Button variant="contained" color="primary">
                                                View
                                            </Button>	
                                        </NavLink> 
                                    </Grid>
                                </Grid>
                            );
                    },download:false //exlclude this column in excel csv
                }
            }
        ];
 
        const options = {
            filter: false,
            filterType: "dropdown",
            selectableRows: "none",
            //filterType: "multiselect",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
			download: false,  //add this
			print: false, //add this
			viewColumns :false,
			downloadOptions: {
                filename : 'InventoryAdjustmentHistory.csv' //change filename of csv
            }
            // tableBodyHeight,
		};
		
		const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<LocalMallIcon />
            				</div>
							<Breadcrumbs aria-label="breadcrumb">
								<NavLink to="/inventory">
									<h2 className="header-title">Inventory</h2>
								</NavLink>
								<Typography color="textPrimary">Inventory Location Transfer Transaction History</Typography>
							</Breadcrumbs>
            			</div>
            			<div className="page-container">
							<div style={style}>
                            <Grid container spacing={1}>
                           	 	<Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
            							<TextField
											id="outlined-basic"
											label="Select Date"
											variant="outlined"
											onFocus={() => setOpen(true)}
											fullWidth={true}
											autoComplete="off"
											value={`${format(
												dateRange.startDate,
												"MM/dd/yyyy"
											)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
										/>
										<DateRangePicker
											open={open}
											toggle={toggle}
											onChange={(range) => dateRangeHandler(range)}
										/> 
									</Grid>
                                    <Grid item xs={1} lg={1} xl={1}>
							            <Button style ={{marginTop: "10px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						            </Grid>
								</Grid>	
							</div>
								
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
            					<MUIDataTable
            						title={
            							<div>
            								<h3 className="header-title" style ={{color: "#339933"}}>
                                          Inventory Location Transfer Transaction History
            								</h3>
            							</div>
            						}
            						data={posts}
            						columns={columns}
            						options={options}
            					/>
            				)}
            			</div>
            		</div>
            	);
};
 
export default InventoryLocationTransfer; 